import { render, staticRenderFns } from "./TestEventsPage.vue?vue&type=template&id=e9bff08c&"
import script from "./TestEventsPage.vue?vue&type=script&lang=js&"
export * from "./TestEventsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports